/* eslint-disable no-plusplus, jsx-a11y/anchor-has-content, array-callback-return, no-restricted-syntax */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import canUseDOM from 'exenv';
import axios from 'axios';

export default class RecircByTag extends Component {
  constructor(props) {
    super(props);

    this.determineIfMobile = this.determineIfMobile.bind(this);

    this.module = null;
    this.container = null;

    this.state = {
      articles: [],
      isMobile: this.determineIfMobile
    };
  }

  componentDidMount() {
    if (canUseDOM) {
      const mql = window.matchMedia('(max-width: 1023px)');
      mql.addListener(this.determineIfMobile);

      const ro = new ResizeObserver(entries => {
        for (const entry of entries) {
          const cr = entry.contentRect;
          document
            .querySelector('.article-recirc-by-tag')
            .closest('.social').style.marginBottom = `${cr.height + 38 + 41}px`;
        }
      });

      ro.observe(document.querySelector('.article-recirc-by-tag'));
    }

    const articles = [];

    axios(
      '//fc-api.fastcompany.com/api/v2/posts-tag-slugs/fastcompany/best-workplaces-for-innovators-2020'
    ).then(res => {
      let count = 0;
      let i = 0;

      while (count < 3) {
        if (res.data.posts[i].id !== this.props.articleId) {
          articles.push(res.data.posts[i]);
          count++;
        }

        i++;
      }

      if (articles.length > 0) {
        this.setState({
          articles
        });
      }
    });
  }

  determineIfMobile(e) {
    this.setState({
      isMobile: e.matches
    });
  }

  render() {
    if (this.state.isMobile === true) return false;

    return (
      <aside className="article-recirc-by-tag">
        <div className="header">
          <div className="arrow">
            <img
              src="https://images.fastcompany.net/image/upload/v1595605760/fcweb/Path_33_zlkv0h.svg"
              alt=""
            />
          </div>

          <div className="package-name">Best Workplaces For Innovators</div>

          <a href="/best-workplaces-for-innovators/2020?icid=dan902:754:0:editRecirc" />
        </div>

        {this.state.articles && (
          <div className="articles">
            {this.state.articles &&
              this.state.articles.map((article, idx) => (
                <div className="article" key={`article-${idx}`}>
                  <a href={`${article.link}?icid=dan902:754:0:editRecirc`}>
                    {article.title}
                  </a>
                </div>
              ))}
          </div>
        )}
      </aside>
    );
  }
}

RecircByTag.defaultProps = {
  articleId: 0
};

RecircByTag.propTypes = {
  articleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
